export const API_ENDPOINTS = {
  auth: {
    sendOTP: { url: '/sessions/validate/login/', method: 'POST' },
    verifyOTP: { url: '/sessions/validate/login/', method: 'POST' },
    requestLoginToken: { url: '/sessions/validate/login/', method: 'POST' },
    loginWithToken: { url: '/sessions/login/', method: 'POST' },
    validateSSO: { url: '/sessions/validate/login/', method: 'POST' },
    checkLogin: { url: '/sessions/check/login/', method: 'GET' },
    countryCodes: { url: '/accounts/country-codes/', method: 'GET' },
  },
  qr: {
    websocket: 'wss://apps.hubbler.in/ws/login/',
  },
} as const;

export type EndpointConfig = {
  url: string;
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
};
